module.exports = __webpack_public_path__ + "static/media/chairman.e27d1846.jpg";